import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./UnsupervisedAlgorithmSelection.css";
import { logout } from "../utils/api";

function UnsupervisedAlgorithmSelection() {
  const [selectedAlgorithms, setSelectedAlgorithms] = useState([]);
  const [time, setTime] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      const currentTime = new Date();
      const hours = currentTime.getHours() % 12 || 12;
      const minutes = currentTime.getMinutes().toString().padStart(2, "0");
      const seconds = currentTime.getSeconds().toString().padStart(2, "0");
      const ampm = currentTime.getHours() >= 12 ? "PM" : "AM";
      setTime(`${hours}:${minutes}:${seconds} ${ampm}`);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
      navigate('/login');
    }
  };

  const algorithms = [
    "K-Means Clustering",
    "Hierarchical Clustering"
  ];

  const handleAlgorithmChange = (algorithm) => {
    setSelectedAlgorithms((prevSelected) =>
      prevSelected.includes(algorithm) ? [] : [algorithm]
    );
  };

  const handleSubmit = () => {
    if (selectedAlgorithms.length === 0) {
      alert("Please select an algorithm.");
      return;
    }
    localStorage.setItem("selectedAlgorithms", JSON.stringify(selectedAlgorithms));
    localStorage.setItem("triggerUnsupervisedTraining", "true");
    navigate("/unsupervised-results");
  };

  return (
    <div className="unsupervised-algorithm-selection">
      {/* Top Navigation Bar */}
      <div className="top-nav">
        <div className="nav-content">
          <div className="nav-left-group">
            <div className="nav-logo" onClick={() => navigate("/")}>
              <img src="/HDASLogo.png" alt="HDAS" style={{ height: "80px", width: "auto" }} />
            </div>
            <button className="back-nav-button" onClick={() => navigate("/dataset-preview")}>
              Back
            </button>
          </div>
          <div className="nav-right">
            <div className="digital-clock">{time}</div>
            <button onClick={handleLogout} className="logout-button">Logout</button>
          </div>
        </div>
      </div>

      {/* Header Section */}
      <div className="page-header">
        <div className="header-content">
          <h1>Select Algorithm</h1>
          <p className="header-subtitle">
            Choose one clustering algorithm to discover patterns and groups in your data.
          </p>
          {selectedAlgorithms.length > 0 && (
            <div className="selection-counter">
              {selectedAlgorithms[0]}
            </div>
          )}
        </div>
      </div>

      {/* Main Content */}
      <div className="page-content">
        <div className="algorithm-grid">
          {algorithms.map((algorithm, index) => {
            const isSelected = selectedAlgorithms.includes(algorithm);
            return (
              <div
                key={index}
                className={`algorithm-card ${isSelected ? "selected" : ""}`}
                onClick={() => handleAlgorithmChange(algorithm)}
              >
                <div className="card-checkbox">
                  {isSelected && <div className="checkmark"></div>}
                </div>
                <div className="card-content">
                  <h3>{algorithm}</h3>
                </div>
              </div>
            );
          })}
        </div>

        {/* Info Box */}
        <div className="info-box">
          <h3>About Clustering Algorithms</h3>
          <p>
            Clustering algorithms group similar data points together without predefined labels. 
            <strong> K-Means</strong> is fast and works well with spherical clusters, while 
            <strong> Hierarchical Clustering</strong> creates a tree-like structure showing relationships 
            at different levels. Both will automatically use all numeric columns from your dataset to discover 
            hidden patterns in your healthcare data.
          </p>
        </div>

        {/* Action Button */}
        <div className="action-section">
          <button 
            className="submit-button" 
            onClick={handleSubmit}
            disabled={selectedAlgorithms.length === 0}
          >
            {selectedAlgorithms.length === 0 
              ? "Select an algorithm to continue"
              : `View Results (${selectedAlgorithms[0]})`}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UnsupervisedAlgorithmSelection;
